module.exports = __webpack_public_path__ + "static/media/danxuanweixuan.02ba23dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/vehicleInquiry/inputPage/images/danxuanweixuan.png
// module id = 1593
// module chunks = 0